module.exports = __webpack_public_path__ + "img/mira_116l_list.2b22d7ab.jpg";